(function () {
    'use strict';

    angular
        .module('invoices')
        .controller('CostCenterModalController', CostCenterModalController);

    CostCenterModalController.$inject = ['$uibModalInstance', '$timeout','CostCenterService', 'category'];
    app.run(function(editableOptions) {
        editableOptions.theme = 'bs3';
    });
    function CostCenterModalController($uibModalInstance, $timeout, CostCenterService, category) {
        var vm = this;
        vm.edit                     = false;
        vm.category                 = category;
        vm.statusList               = [{name:'Active'}, {name:'Inactive'}];
        vm.subcategoryList          = [];
        vm.isAllSelected            = false;
        vm.getSubcategories         = getSubcategories;
        vm.getInvoiceStatusLabel  = getInvoiceStatusLabel;
        vm.getInvoiceStatusClass  = getInvoiceStatusClass;
        vm.save                   = save;
        vm.editSubcategory        = editSubcategory;
        vm.cancel                 = cancel;

        activate();

        function activate() {
            vm.getSubcategories();
        }

        function getSubcategories() {
            if(vm.category.id) {
                CostCenterService.getInvoicesCostCenterSubcategory(vm.category.id).then(function(response) {
                    vm.subcategoryList = response.data.data;
                }).catch(function (err) {
                });
            }
        }

        function getInvoiceStatusLabel(status) {
            return status;
        }

        function getInvoiceStatusClass(status) {
            if (status === 'Active') {
                return 'label-success';
            }
            return 'label-danger';
        }

        function save() {
            var query = {};

            // if(vm.amountToBePaid !== '') {
            //     query['amount_to_be_paid'] = vm.amountToBePaid;
            // }
            //
            // query['status']         = vm.invoice.status;
            // query['creation_date']  = vm.invoice.created_at;
            // query['currency']       = vm.invoice.currency;
            // query['invoice_id']     = vm.invoice.id;
            var query = {};
            query.invoices = vm.invoicesPaymentsList.filter(function(item) {
                if(item.selected === true) {
                    return item.id;
                }
            });
            // if(query['invoices']){
            //     InvoicesService.deleteInvoicePayment(query).then(function(response) {
            //         vm.getInvoicePaymentHistory();
            //     }).catch(function(err) {
            //     });
            // }
        }

        function editSubcategory(subcategory) {

        }

        function cancel() {
            $uibModalInstance.close();
        }
    }

})();